import { type WithTextSubSelector } from "@client/content/types";
import TextStyle, { type TextStyleProps } from "@client/controls/Style/Text";
import { getEntitySelector } from "@client/lib/layout";
import { connectCustom, joinDefined } from "@client/lib/misc";
import { TargetSelector, type WithPrefix, getTextSettingSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";

export type ContentTextStyleProps = EntityRef &
  Partial<WithTextSubSelector> &
  Partial<WithPrefix> & {
    selector?: string;
  };
const makeMapStateToProps = () => {
  const settingSelector = getTextSettingSelector(TargetSelector.Entity);

  return (state: AppState, props: ContentTextStyleProps): TextStyleProps => ({
    ...props,
    selector: joinDefined(" ", props.selector ?? getEntitySelector(props.id), props.textSubSelector),
    value: settingSelector(state, props)
  });
};

const ContentTextStyle = connectCustom(makeMapStateToProps)(TextStyle);
export default ContentTextStyle;
